import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import QuickFilter from 'components/atoms/GefMui/QuickFilter';
import ToolbarTemplate from 'components/atoms/GefMui/ToolbarTemplate/ToolbarTemplate';
import { loadWithQuickFilter, resetFormCriteria } from 'features/views/unlockedClients/actions';
import { quickFilterTypesSetup } from 'features/views/unlockedClients/constants';
import { getQuickFilterState } from 'features/views/unlockedClients/selectors';

export const Toolbar = () => {
	const dispatch = useDispatch();
	const quickFilter = useSelector(getQuickFilterState);

	const handleOnChange = useCallback(
		(type) => {
			dispatch(loadWithQuickFilter(type));
		},
		[dispatch],
	);

	const handleOnReset = useCallback(() => {
		dispatch(resetFormCriteria());
	}, [dispatch]);

	return (
		<ToolbarTemplate
			leftSide={
				<QuickFilter
					quickFilterState={quickFilter}
					quickFilterTypesSetup={quickFilterTypesSetup}
					onChange={handleOnChange}
					onReset={handleOnReset}
				/>
			}
		/>
	);
};

export default Toolbar;
